var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RequestForm',{attrs:{"type":"add","save-action":_vm.createItemAction,"back":_vm.back,"error":_vm.error,"loading":_vm.loading,"saved":_vm.created,"getServices":_vm.getServices,"findAllServices":_vm.findAllServices,"findRequest":_vm.findRequest,"updateRequest":_vm.updateRequest,"authService":_vm.authService}})
}
var staticRenderFns = []

export { render, staticRenderFns }